import * as React from 'react'
import { renderActivityCard } from '../../common/helpers/activitiesHelpers'
import { Card } from '../../components/Card/Card'
import NotificationsWrapper from '../../components/Notification/NotificationsWrapper'
import {
  CompanyId,
  GoalId,
  GoalWithProgress,
  ProgressType,
  Role,
  ServiceProvider,
  UserProfileDto,
} from '../../services/api.types'
import YumGoalRankingWrapper from '../../components/YumGoalRanking/YumGoalRankingWrapper'
import YumUserActivityWrapper from '../../components/YumUserActivity/YumUserActivityWrapper'
import YumGoalListWrapper from '../../components/YumGoalList/YumGoalListWrapper'
import { isCollectiveType } from '../../common/helpers/challenges'
import { Grid } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import { t } from 'ttag'
import YumCustomEntryWrapper from '../../components/YumCustomEntry/YumCustomEntryWrapper'
import { currentLang } from '../../i18nInit'
import { store } from '../../index'
import { push } from 'connected-react-router'
import { PluginListenerHandle } from '@capacitor/core'
import { App } from '@capacitor/app'
import { isNative } from '../../common/helpers/isNative'

export interface IStateProps {
  hasRoleInCompany(companyId: CompanyId, role: Role): boolean
  goalId: GoalId | null
  token: string | undefined
  goals: GoalWithProgress[]
  goalsDtoLoading: boolean
  userDto: UserProfileDto
}

export interface IDispatchProps {
  getCompanyDivisions(): void
  getUserCompanyCountries(): void
  getCurrentCompanyGoal(payload: { id?: GoalId | null; silentGoalUpdate?: boolean; token?: string | null }): void
  getCurrentGoalActivityListClear(payload?: { goalId: string; clearAll?: boolean }): void
}

type IActivityProps = IStateProps & IDispatchProps

let appStateChangeListener: PluginListenerHandle

export class Activity extends React.PureComponent<IActivityProps> {
  state = { showManualEntry: false }

  getChallenges() {
    console.log('Activity | getChallenges')
    const { token, goalId } = this.props

    if (token) {
      if (goalId) {
        this.props.getCurrentGoalActivityListClear({ goalId, clearAll: true })
        this.props.getCurrentCompanyGoal({ id: goalId, token })
      }
    } else {
      this.props.getUserCompanyCountries()
      this.props.getCompanyDivisions()
      this.props.getCurrentCompanyGoal({ id: this.props.goalId, silentGoalUpdate: true })
    }
  }

  componentDidMount(): void {
    const { token, goalId } = this.props

    // !!! REDIRECT TO NEW VIEW !!!
    if (goalId && !token) {
      store.dispatch(push(`/challenges/${goalId}/ranking`))
      return
    }

    this.getChallenges()

    if (isNative()) {
      appStateChangeListener = App.addListener('appStateChange', async ({ isActive }) => {
        if (isActive) {
          console.log('Activity | APP RESUME | getChallenges')
          this.getChallenges()
        }
      })
    }
  }

  componentWillUnmount() {
    if (isNative()) {
      console.log('Activity | Removing appStateChangeListener')
      appStateChangeListener?.remove()
    }
  }

  toggleShowManualEntry = () => {
    this.setState({ showManualEntry: !this.state.showManualEntry })
  }

  render() {
    const { hasRoleInCompany, goalId, goals, goalsDtoLoading, token } = this.props

    const goal: GoalWithProgress | undefined = goals ? goals.find(({ id }) => id === goalId) : undefined
    // const hasMultipleGoals: boolean = goals && goals.length > 0
    // const listView: boolean = hasMultipleGoals && !goalId
    const listView = !goalId
    const serviceProvider = this.props.userDto.serviceProvider as ServiceProvider
    const isUser = goal ? hasRoleInCompany(goal.companyId, Role.USER) : false
    const isCustom =
      goal?.progressType === ProgressType.CUSTOM ||
      goal?.progressType === ProgressType.PERSISTENCE_CUSTOM ||
      goal?.progressType === ProgressType.PERSISTENCE_CUSTOM_BINARY

    return (
      <>
        <NotificationsWrapper />

        {listView ? (
          <YumGoalListWrapper goals={goals} loading={goalsDtoLoading} />
        ) : (
          <>
            {renderActivityCard(goalsDtoLoading, goal, currentLang)}

            {goal ? (
              <Card>
                {isCustom && isUser ? (
                  <>
                    <Grid
                      container={true}
                      justifyContent="space-between"
                      alignContent="center"
                      alignItems="center"
                      item={true}
                      style={{ whiteSpace: 'nowrap', marginBottom: 10 }}
                    >
                      <Grid item>
                        <Typography variant="caption">{t`Your progress`}</Typography>
                      </Grid>
                    </Grid>
                    <YumCustomEntryWrapper
                      goal={goal}
                      showManualEntry={this.state.showManualEntry}
                    ></YumCustomEntryWrapper>
                  </>
                ) : (
                  ''
                )}

                {!isCustom && (isUser || isCollectiveType(goal.progressType)) && (
                  <YumUserActivityWrapper goalDto={goal} serviceProvider={serviceProvider} isUser={isUser} />
                )}
                {goal.id && <YumGoalRankingWrapper goalDto={goal} token={token} />}
              </Card>
            ) : (
              ''
            )}
          </>
        )}
      </>
    )
  }
}
